<template>
  <DataTable v-bind="attrs">
    <template #loading>
      <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-8 tw-gap-2">
        <i class="!tw-text-text fas fa-2x fa-spinner fa-spin"></i>
        <template v-if="props.loadingMessage">
          <div class="tw-text-text">{{ props.loadingMessage }}</div>
        </template>
      </div>
    </template>
    <template #paginatorcontainer="p">
      <div class="tw-flex tw-items-center tw-gap-4 tw-w-full tw-justify-between">
        <div v-if="props.rowsPerPageOptions" class="tw-flex tw-items-center tw-gap-2">
          <Dropdown
            :options="props.rowsPerPageOptions"
            :value="attrs.rows"
            @change="(e: SelectChangeEvent) => p.rowChangeCallback(e.value)"
            :placeholder="p.rows?.toString() || 'Rows'" />
          <span>Items per page</span>
        </div>
        <div>
          <Paginator
            :first="p.first"
            :rows="p.rows"
            :totalRecords="p.totalRecords"
            @page="(e: PageState) => p.changePageCallback(e.page)"
            template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink" />
        </div>
      </div>
    </template>
    <template v-for="(_, slotName) in slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps" />
    </template>
    <template v-for="col in props.columns" :key="col.field">
      <Column
        v-if="col.selectionMode"
        :selectionMode="col.selectionMode"
        :style="col.style"
        :headerStyle="col.headerStyle" />
      <Column
        v-else
        :field="col.field"
        :header="col.header"
        :sortable="col.sortable"
        :style="col.style"
        :headerStyle="col.headerStyle">
        <template #body="{ data }">
          <component v-if="col.content" :is="col.content(data)" />
          <template v-else-if="$slots[col.field]">
            <slot :name="col.field" :data="data" />
          </template>
          <span v-else>{{ data?.[col.field] }}</span>
        </template>
      </Column>
    </template>
    <slot />
  </DataTable>
</template>

<script setup lang="ts">
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Paginator, { PageState } from 'primevue/paginator'
import Dropdown from '@/components/Tailwind/Dropdown/Dropdown.vue'
import { useAttrs, useSlots } from 'vue'
import { SelectChangeEvent } from 'primevue/select'
import { type TableProps } from './types'

const props = defineProps<TableProps>()
const attrs = useAttrs()
const slots = useSlots()
</script>
